import { Component, OnInit, NgZone } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { Router } from '@angular/router';

import { User } from '../autenticacion/models/user';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {

    //Input()
    user: User | null;
    mobile : Boolean = false;

    constructor(private afAuth: AngularFireAuth,
        private ngZone: NgZone,
        private router: Router) { }

    ngOnInit(): void {
        
        if (window.screen.width < 1024) { // 768px portrait
            this.mobile = true;
        }
        console.log("width: " + window.screen.width);
        console.log("mobile: " + this.mobile);
  
        this.afAuth.onAuthStateChanged(user => {
            if (user) {
                this.user = user;
            } else {
                this.user = null;
                this.ngZone.run(() => {
                    this.router.navigate(['']);
                })
            }
        });
    }

    logout() {
        this.afAuth.signOut();

    }

}
